<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-orders-returns-edit-return')) {
      <ion-item button="true" (click)="presentOrderReturnEditModal()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
